import { useContext, useEffect } from "react";
import { Moon, Sun } from "lucide-react";
import HeroSection from "@/components/home/HeroSection";
import EditorialMarquee from "@/components/EditorialMarquee";
import ProblemSection from "@/components/home/ProblemSection";
import GapSection from "@/components/home/GapSection";
import ServiceModelSection from "@/components/home/ServiceModelSection";
import ExperienceSection from "@/components/home/ExperienceSection";
import FollowTheErrorSection from "@/components/home/FollowTheErrorSection";
import CtaBand from "@/components/CtaBand";
import ComparePill from "@/components/ComparePill";
import { StyleBContext } from "@/theme/styleb-context";

export default function StyleBPage() {
  const { theme, toggle } = useContext(StyleBContext);

  useEffect(() => {
    document.title = "Style B Preview — Improve Systems";
    const meta = document.createElement("meta");
    meta.setAttribute("name", "robots");
    meta.setAttribute("content", "noindex, nofollow");
    meta.setAttribute("data-styleb", "");
    document.head.appendChild(meta);
    return () => meta.remove();
  }, []);

  return (
    <div data-testid="styleb-page">
      <HeroSection />
      <EditorialMarquee />
      <ProblemSection />
      <GapSection />
      <ServiceModelSection />
      <ExperienceSection />
      <FollowTheErrorSection />
      <CtaBand />
      <ComparePill to="/stylea" label="VIEW STYLE A — CURRENT" />
      <button
        type="button"
        data-testid="styleb-theme-toggle"
        onClick={toggle}
        aria-label={theme === "dark" ? "Switch to light theme" : "Switch to dark studio theme"}
        className="fixed bottom-6 right-6 z-50 flex items-center gap-2 px-4 py-2.5 font-mono text-[11px] tracking-[0.2em] text-white shadow-lg transition-transform duration-200 hover:-translate-y-0.5"
        style={{ backgroundColor: "var(--sb-accent)" }}
      >
        {theme === "dark" ? (
          <Moon className="h-3.5 w-3.5" aria-hidden="true" />
        ) : (
          <Sun className="h-3.5 w-3.5" aria-hidden="true" />
        )}
        {theme === "dark" ? "STYLE B — STUDIO" : "STYLE B — LIGHT"}
      </button>
    </div>
  );
}
